import { render } from "./IconDiscord.vue?vue&type=template&id=42892246&scoped=true"
import script from "./IconDiscord.vue?vue&type=script&lang=js"
export * from "./IconDiscord.vue?vue&type=script&lang=js"

import "./IconDiscord.vue?vue&type=style&index=0&id=42892246&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42892246"]])

export default __exports__